let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3DeMa")).then(() => parcelRequire('eFKMG'));